

// import { createContext, useEffect, useState } from "react";

// export const AuthContext = createContext();

// export const AuthContextProvider = ({ children }) => {
//   // const [currentUser, setCurrentUser] = useState(
//   //   JSON.parse(localStorage.getItem("ocos")) || null
//   // );

//   const [currentUser, setCurrentUser] = useState(() => {
//     const storedData = localStorage.getItem("ocos");
//     if (!storedData) return null;

//     const { user, timestamp } = JSON.parse(storedData);
//     const isExpired = Date.now() - timestamp > 24 * 60 * 60 * 1000; // 24 hours in milliseconds

//     if (isExpired) {
//       localStorage.removeItem("ocos");
//       return null;
//     }

//     return user;
//   });

//   const login = async (portal_id, password) => {
//     try {
//       const formData = new FormData();
//       formData.append("portalID", portal_id);
//       formData.append("password", password);
//       formData.append("apiKey", "12RT5HWI9Y00FFG3");

//       // Login request to the authentication API
//       const response = await fetch(
//         "https://mobileapizx.blwstaffportal.org/apiauth/login",
//         {
//           method: "POST",
//           body: formData,
//         }
//       );

//       const data = await response.json();

//       if (!response.ok || data.status === false) {
//         throw new Error(data.message || "Invalid portal ID or password");
//       }

//       // Set current user and store user data in localStorage
//       // setCurrentUser(data.user);
//       // localStorage.setItem("ocos", JSON.stringify(data.user));
//       // Set current user and store user data in localStorage
//       const userDataWithTimestamp = {
//         user: data.user,
//         timestamp: Date.now(), // Store current time in milliseconds
//       };

//       setCurrentUser(data.user);
//       localStorage.setItem("ocos", JSON.stringify(userDataWithTimestamp));

//       // Send user data to your backend database
//       await saveUserToDatabase(data.user);
//     } catch (error) {
//       console.error("Login failed:", error);
//       throw error;
//     }
//   };

//   useEffect(() => {
//     const storedData = localStorage.getItem("ocos");
//     if (!storedData) return;

//     const { timestamp } = JSON.parse(storedData);
//     const timeLeft = 24 * 60 * 60 * 1000 - (Date.now() - timestamp);

//     const timer = setTimeout(() => {
//       logout(); // Automatically log out after 24 hours
//     }, timeLeft);

//     return () => clearTimeout(timer); // Clean up timer on unmount or change
//   }, [currentUser]);

//   // Function to send user data to the backend /save endpoint
//   const saveUserToDatabase = async (user) => {
//     try {
//       const response = await fetch("http://162.210.199.3:3001/savelng", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ user }), // Send user data in request body
//       });

//       const result = await response.json();
//       if (!response.ok) {
//         throw new Error(result.message || "Failed to save user data");
//       }

//       console.log(result.message); // 'User data saved successfully'
//     } catch (error) {
//       console.error("Failed to save user data:", error);
//     }
//   };

//   // Logout function
//   const logout = () => {
//     setCurrentUser(null); // Clear the current user state
//     localStorage.removeItem("ocos"); // Clear user data from localStorage
//   };

//   // useEffect(() => {
//   //   if (currentUser) {
//   //     localStorage.setItem("ocos", JSON.stringify(currentUser));
//   //   }
//   // }, [currentUser]);
//   useEffect(() => {
//     if (currentUser) {
//       const dataToStore = {
//         user: currentUser,
//         timestamp: Date.now(), // Reset timestamp on login or user change
//       };
//       localStorage.setItem("ocos", JSON.stringify(dataToStore));
//     }
//   }, [currentUser]);

//   return (
//     <AuthContext.Provider value={{ currentUser, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };



import { createContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(() => {
    const storedData = localStorage.getItem("ocos");
    if (!storedData) return null;

    const { user, timestamp } = JSON.parse(storedData);
    const isExpired = Date.now() - timestamp > 24 * 60 * 60 * 1000;

    if (isExpired) {
      localStorage.removeItem("ocos");
      return null;
    }

    return user;
  });

  // Admin login function
  const adminLogin = (portal_id, password) => {
    const ADMIN_CREDENTIALS = {
      portal_id: 'ocosadmin',
      password: '0907admin'
    };

    if (portal_id === ADMIN_CREDENTIALS.portal_id && password === ADMIN_CREDENTIALS.password) {
      // Create admin user with same structure as regular user
      const adminUser = {
        portalID: portal_id,
        isAdmin: true,
        title: 'Admin',
        firstName: 'OCOS',
        lastName: 'Admin',
        deptName: 'Administration',
        picturePath: 'https://cdn1.kingschat.online/uploads/media/5b7f105655d23a0030a01215/M25TaVlldXJGbmg4ZFE5akNhaTBYZz09/stdlTv.png',
        name: 'OCOS Admin',
        role: 'Administrator'
      };

      const userDataWithTimestamp = {
        user: adminUser,
        timestamp: Date.now(),
      };

      localStorage.setItem("ocos", JSON.stringify(userDataWithTimestamp));
      localStorage.setItem("adminUser", JSON.stringify(userDataWithTimestamp));
      
      setCurrentUser(adminUser);
      return true;
    }
    return false;
  };

  const login = async (portal_id, password) => {
    try {
      const formData = new FormData();
      formData.append("portalID", portal_id);
      formData.append("password", password);
      formData.append("apiKey", "12RT5HWI9Y00FFG3");

      const response = await fetch(
        "https://mobileapizx.blwstaffportal.org/apiauth/login",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (!response.ok || data.status === false) {
        throw new Error(data.message || "Invalid portal ID or password");
      }

      const userDataWithTimestamp = {
        user: data.user,
        timestamp: Date.now(),
      };

      setCurrentUser(data.user);
      localStorage.setItem("ocos", JSON.stringify(userDataWithTimestamp));

      await saveUserToDatabase(data.user);
    } catch (error) {
      console.error("Login failed:", error);
      throw error;
    }
  };

  useEffect(() => {
    const storedData = localStorage.getItem("ocos");
    if (!storedData) return;

    const { timestamp } = JSON.parse(storedData);
    const timeLeft = 24 * 60 * 60 * 1000 - (Date.now() - timestamp);

    const timer = setTimeout(() => {
      logout();
    }, timeLeft);

    return () => clearTimeout(timer);
  }, [currentUser]);

  const saveUserToDatabase = async (user) => {
    try {
      const response = await fetch("http://162.210.199.3:3001/savelng", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user }),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || "Failed to save user data");
      }

      console.log(result.message);
    } catch (error) {
      console.error("Failed to save user data:", error);
    }
  };

  const logout = () => {
    setCurrentUser(null);
    localStorage.removeItem("ocos");
    localStorage.removeItem("adminUser");
  };

  useEffect(() => {
    if (currentUser) {
      const dataToStore = {
        user: currentUser,
        timestamp: Date.now(),
      };
      localStorage.setItem("ocos", JSON.stringify(dataToStore));
    }
  }, [currentUser]);

  return (
    <AuthContext.Provider value={{ currentUser, login, logout, adminLogin }}>
      {children}
    </AuthContext.Provider>
  );
};